import React from 'react';
import PostSendModal from '../PostSendModal/PostSendModal';
import { Icon, Subtitle } from '@landing/ui';
import { defaultModalsId } from '../constants';

import * as styles from './SuccessModal.module.scss';

export default function SuccessModal() {
  const getIcon = () => <Icon name="letter-success" className={styles.icon} />;

  return (
    <PostSendModal Icon={getIcon} modalID={defaultModalsId.successModal}>
      <div className={styles.wrapper}>
        <Subtitle className={styles.text}>
          {'Thank you for your registration.\n\rYou will receive an email from our team shortly.'}
        </Subtitle>
      </div>
    </PostSendModal>
  );
}
